import {
  APPEARANCE_TOKENS,
  appearanceTokens,
  type AppearanceTokens,
} from './appearance-colour.util';
import type { AppearanceLook } from './appearance.util';

/**
 * Set on `<html>` while a colour is picked. `index.css` maps the `--ap-*`
 * variables onto the chrome's tokens only under it, and `.dark` picks the dark
 * set, so a mode switch needs no script.
 */
export const APPEARANCE_ATTRIBUTE = 'data-appearance';

/** Writes the variables on the root, or clears them for today's chrome. */
export function applyAppearanceTokens(
  root: HTMLElement,
  tokens: AppearanceTokens | null
): void {
  if (!tokens) {
    clearAppearance(root);
    return;
  }
  for (const name of APPEARANCE_TOKENS)
    root.style.setProperty(name, tokens[name]);
  root.setAttribute(APPEARANCE_ATTRIBUTE, '');
}

/** Paints a look on the root: its variables, or today's chrome with none. */
export function applyAppearance(
  root: HTMLElement,
  look: AppearanceLook | null
): void {
  applyAppearanceTokens(root, look ? appearanceTokens(look) : null);
}

/** Removes every variable and the attribute: today's chrome. */
export function clearAppearance(root: HTMLElement): void {
  for (const name of APPEARANCE_TOKENS) root.style.removeProperty(name);
  root.removeAttribute(APPEARANCE_ATTRIBUTE);
}
